import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// Scroll to the top of the page on navigation to a NEW route, but leave
// browser Back/Forward alone. On a POP (back/forward) the browser restores the
// previous scroll position itself (scrollRestoration defaults to 'auto'); forcing
// a scroll-to-top there fights that restore, so a first Back only appears to move
// the scroll and it takes a second Back to actually navigate. Skipping POP lets
// Back behave normally while PUSH/REPLACE still start at the top.
const ScrollToTop: React.FC = () => {
    const { pathname } = useLocation();
    const navigationType = useNavigationType();
    useEffect(() => {
        if (navigationType === 'POP') return;
        window.scrollTo({ top: 0, left: 0 });
    }, [pathname, navigationType]);
    return null;
};

export default ScrollToTop;
